import React from 'react';
import { FaGavel, FaGlobeAmericas, FaHandshake, FaLaptopCode, FaUsers } from 'react-icons/fa';
import '../../styles/MinisterialAward.css';

export default function MinisterialAward() {
  const categories = [
    {
      icon: <FaGavel />,
      title: 'Digital Policy & Reform',
      desc: 'Honouring transformative legislation and visionary national strategy that reshapes the digital landscape.'
    },
    {
      icon: <FaUsers />,
      title: 'Digital Access & Equity',
      desc: 'Recognizing bold leadership in bridging the digital divide and empowering every citizen to participate in the digital age.'
    },
    {
      icon: <FaLaptopCode />,
      title: 'National Digital Transformation',
      desc: 'Celebrating the strategic use of ICT to drive progress across education, health, finance, climate resilience, and governance.'
    },
  ];

  const categoriesBottom = [
    {
      icon: <FaGlobeAmericas />,
      title: 'Regional & Global Digital Cooperation',
      desc: 'Acknowledging leadership that strengthens Caribbean collaboration and advances alignment with international digital priorities.'
    },
    {
      icon: <FaHandshake />,
      title: 'Digital Investment & Strategic Partnerships',
      desc: 'Honouring the mobilization of capital, innovation, and public-private collaboration to accelerate digital economic growth.'
    },
  ];

  return (
    <div className='ministerial-page'>
      {/* Banner / Video Section */}
      <div className='ministerial-banner'>
        <video autoPlay muted loop playsInline>
          <source src={process.env.PUBLIC_URL + '/assets/ministerial_award_video.mp4'} type='video/mp4' />
        </video>
        <div className='ministerial-banner-overlay'>
          <div className='ministerial-banner-title'>
            CANTO Ministerial Award for ICT Leadership & Digital Transformation
          </div>
          <div className='ministerial-banner-subtitle'>
            Celebrating Visionary Ministers Advancing the Caribbean's Digital Future
          </div>
        </div>
      </div>

      {/* About / Introduction */}
      <div className='ministerial-about'>
        <div className='ministerial-about-label'>About the Award</div>
        <div className='ministerial-about-text'>
          The CANTO Ministerial Award for ICT Leadership & Digital Transformation shines a spotlight on visionary Ministers who are boldly advancing the region's digital future. Celebrating exceptional leadership, the award recognizes those turning ambition into action, driving innovation, expanding connectivity, and unlocking opportunities for citizens and businesses alike. More than an accolade, it's a powerful call to action, inspiring governments to place ICT at the heart of sustainable development, inclusive growth, and a thriving digital society.
        </div>
        <a
          href={process.env.PUBLIC_URL + '/assets/ministerial_award_about.pdf'}
          target='_blank'
          rel='noopener noreferrer'
          className='ministerial-about-btn'
        >
          About the Awards
        </a>
      </div>

      {/* Call to Action */}
      <div className='ministerial-cta'>
        <div className='ministerial-cta-title'>A Call to Recognize Exceptional Leadership</div>
        <div className='ministerial-cta-subtitle'>
          "Honouring Caribbean Excellence in Digital Leadership — Be Part of the Legacy."
        </div>
        <a
          href={process.env.PUBLIC_URL + '/assets/ministerial_award_nomination.pdf'}
          target='_blank'
          rel='noopener noreferrer'
          className='ministerial-cta-btn'
        >
          Submit Your Nomination
        </a>
      </div>

      {/* Categories / Areas of Review */}
      <div className='ministerial-categories'>
        <div className='ministerial-categories-label'>Areas of Review</div>
        <div className='ministerial-categories-title'>Key Areas of Assessment</div>
        <div className='ministerial-categories-grid'>
          {categories.map((cat, i) => (
            <div className='ministerial-category-card' key={i}>
              <div className='ministerial-category-icon'>{cat.icon}</div>
              <div className='ministerial-category-title'>{cat.title}</div>
              <div className='ministerial-category-desc'>{cat.desc}</div>
            </div>
          ))}
        </div>
        <div className='ministerial-categories-grid-bottom'>
          {categoriesBottom.map((cat, i) => (
            <div className='ministerial-category-card' key={i}>
              <div className='ministerial-category-icon'>{cat.icon}</div>
              <div className='ministerial-category-title'>{cat.title}</div>
              <div className='ministerial-category-desc'>{cat.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Nomination Guidelines */}
      <div className='ministerial-guidelines'>
        <div className='ministerial-guidelines-text'>
          Click on the button below to view the Nomination Guidelines for the CANTO Ministerial Award for ICT Leadership & Digital Transformation.
        </div>
        <a
          href={process.env.PUBLIC_URL + '/assets/ministerial_award_guidelines.pdf'}
          target='_blank'
          rel='noopener noreferrer'
          className='ministerial-guidelines-btn'
        >
          Nomination Guidelines
        </a>
      </div>

      {/* Footer Alert */}
      <div className='ministerial-footer-alert'>
        <div className='ministerial-footer-alert-divider' />
        <div className='ministerial-footer-deadline'>Deadline for Submission of Nominations</div>
        <div className='ministerial-footer-contact'>
          For Additional Information email: <a href='mailto:canto@canto.org'>canto@canto.org</a>
        </div>
        <div className='ministerial-footer-subject'>
          Subject: CANTO Ministerial Innovation Awards
        </div>
      </div>
    </div>
  );
}
